import React, { useRef } from "react";
import { InputNumber } from "antd";
import handleTabIndex from "../Utils/HandleTabIndex";

export const InputNumero = React.forwardRef(({ onChange, value, size, showCurrency = true, onFocus, onBlur, ...props }, ref) => {
  const inputRef = useRef(ref);
  const refPadrao = !!ref && !props.formItem ? ref : inputRef;

  const keyPress = e => {

    if (e.keyCode === 13)
      handleTabIndex(props.tabIndex, props.nextTab);
  };

  const formatter = (value, info) => {

    if (!info.userTyping) {
      if (!value.includes('.')) {
        if (value?.length)
          value += ',00';
      } else {
        const [integerPart, decimalPart] = value.split('.');
        value = `${integerPart},${decimalPart.padEnd(props.precision || 2, '0')}`;
      }
    }

    return value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };
  return <InputNumber
    onKeyDown={keyPress}
    prefix={showCurrency && <span>R$</span>}
    formatter={formatter}
    parser={(value) => value?.replace(/R\$\s?|(\.*)/g, '').replace(',', '.')}
    value={value}
    onChange={onChange}
    size={size ? size : "default"}
    {...props}
    onBlur={v => {
      if (!v.target.value && !props.nullable)
        onChange(props.min || 0);

      if (!!onBlur)
        onBlur(v);
    }}
    onFocus={v => {
      if (!!onFocus)
        onFocus(v);

      refPadrao.current?.select();
    }}
    ref={refPadrao}
    style={{ width: "100%", ...props.style }}
  />;
});

export const InputNumeroPercent = React.forwardRef(({ onChange, value, size, onFocus, onBlur, ...props }, ref) => {
  const inputRef = useRef(ref);
  const refPadrao = !!ref ? ref : inputRef;

  const keyPress = e => {
    if (e.keyCode === 13)
      handleTabIndex(props.tabIndex, props.nextTab);
  };

  return <InputNumber
    onKeyDown={keyPress}
    min={-100}
    max={100}
    value={value}
    onChange={onChange}
    {...props}
    prefix="%"
    onBlur={v => {
      if (!v.target.value)
        onChange(props.min || 0);

      if (!!onBlur)
        onBlur(v);
    }}
    onFocus={v => {
      if (!!onFocus)
        onFocus(v);

      refPadrao.current?.select();
    }}
    ref={refPadrao}
    style={{ width: "100%", ...props.style }}
  />;
});